// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../node_modules/postcss-loader/dist/cjs.js!../../components/library/style/breakpoint.css";
import ___CSS_LOADER_ICSS_IMPORT_1___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../node_modules/postcss-loader/dist/cjs.js!../../components/library/style/colors.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.I1i0baKYJaJf9mmLeqcn {
  width: 100%;
  margin: auto;
  position: relative;
  background: linear-gradient(90deg, rgba(248,250,255,1) 0%, rgba(248,250,255,1) 35%, rgba(255,255,255,1) 100%);
}

.AsNDCWieqtYSFydPs9C_ {
  width: 100%;
  max-width: 1440px;
  margin: auto;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.osMEvPrmWffBIa5oYfUf {
  background-color: #F8FAFF;
  min-height: calc(100vh - 75px);
  width: 65%;
  padding: 16px 32px 48px 0;
  box-sizing: border-box;
}

.TXfRDDLWBXYXUPKU9Lu3 {
  width: 50%;
}

.F5qt7iAYuutJGTGWOjlw {
  color: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-text-subtle"]};
}

.XDPtHezfCUijCss0LV4A {
  margin-top: 32px;
}

.XrBJoS6b31pPaKsMvqGq {
  color: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-purple"]};
  margin: 0 4px;
}

.QkoJ3qhs9MuLwFwLxKjf {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: flex-end;
  margin: 32px 0;
}

._c7v1tRfVVLWGwPfP_AL {
  margin-right: 24px;
}

.MIbn3hbMAElVwIQggRic {
  font-weight: 400;
  color: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-purple"]};
  text-decoration: underline;
}

.AsNDCWieqtYSFydPs9C_ {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.pBTD_GVMGJk6GGFaeM8r {
  width: 49%;
}

.cuDzD625J6ae9Z9jeHAB {
  width: 35%;
}

.gO0WqHvnakkrv3S2oqEe {
  width: 60%;
}

.TZ3znXv7xT9XKwRDNyqP {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 1000;

  width: 100%;
  height: 100vh;

  display: flex;
  justify-content: center;
  align-items: center;

  background-color: rgba(0, 0, 0, 0.15);
}

.CjjEHaIHqFgQc9YdrBYL {
  background-color: white;
  border-radius: 5px;
  padding: 24px;
  width: 500px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.CjjEHaIHqFgQc9YdrBYL h1 {
  font-size: 24px;
  margin: 0;
}

.CjjEHaIHqFgQc9YdrBYL p {
  text-align: center;
}

.CjjEHaIHqFgQc9YdrBYL button {
  width: 100%;
}

.nEVtP4tS6RwVrBCTgKQk {
  background-color: #EDFAF4;
  width: 80px;
  height: 80px;
  border-radius: 80px;

  display: flex;
  align-items: center;
  justify-content: center;

  margin: auto;
}

.ryaRE5G6WbH09UicHFbg {
  font-family: Roboto, sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 21px;
  letter-spacing: 0.005em;
  margin-bottom: 0;
  margin-top: 0;
}

.uJbbHv89TbfWTdNgbeGX {
  font-family: Roboto, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 150%;
  letter-spacing: 0.005em;
  color: rgba(0, 0, 0, 0.55);
  margin-top: 8px;
  margin-bottom: 8px;
  width: 100%;
}

.vYrZluzCt4pGEywK2cMk {
  width: 100%;
}

.RuBaiUJ24YWwTalBJegw {
  display: flex;
  width: 100%;
}

.tT6mXb4RO6xmNZQGOPXe {
  display: none;
}

.voFRNNluY9MferQhrPY3 {
  display: flex;
}

@media screen and (max-width: 1440px) {
  .AsNDCWieqtYSFydPs9C_ {
    width: 90%;
  }
}

@media screen and (max-width: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["tablet"]}) {
  .osMEvPrmWffBIa5oYfUf {
    max-height: calc(90vh - 75px);
    min-height: unset;
    overflow-y: scroll;
  }

  .tT6mXb4RO6xmNZQGOPXe {
    display: block;
  }

  .RuBaiUJ24YWwTalBJegw.tT6mXb4RO6xmNZQGOPXe {
    margin-top: 16px;
    font-size: 16px;
    padding: 16px;
  }

  .voFRNNluY9MferQhrPY3 {
    display: none;
  }

  .CjjEHaIHqFgQc9YdrBYL {
    width: 90%;
    box-sizing: border-box;
  }

  .AsNDCWieqtYSFydPs9C_ {
    flex-direction: column;
  }

  .osMEvPrmWffBIa5oYfUf {
    width: 100%;
    padding: 16px;
    margin-top: 0;
    box-sizing: border-box;

    position: fixed;
    top: 75px;
  }

  .nEVtP4tS6RwVrBCTgKQk {
    width: 60px;
    height: 60px;
    margin-bottom: 16px;
  }
}

@media screen and (max-width: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["tablet-l"]}) {
  .TXfRDDLWBXYXUPKU9Lu3 {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/Confirmation/Confirmation.module.css"],"names":[],"mappings":"AAMA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6GAA6G;AAC/G;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,UAAU;EACV,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mDAAwB;AAC1B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mDAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mDAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,aAAa;;EAEb,WAAW;EACX,aAAa;;EAEb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;;EAEnB,qCAAqC;AACvC;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,YAAY;;EAEZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,mBAAmB;;EAEnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,0BAA0B;EAC1B,eAAe;EACf,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,6BAA6B;IAC7B,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,UAAU;IACV,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,aAAa;IACb,sBAAsB;;IAEtB,eAAe;IACf,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,WAAW;EACb;AACF","sourcesContent":["@value breakpoints: \"components/library/style/breakpoint.css\";\n@value desktop, laptop, tablet-l, tablet, mobile, mobile-xs from breakpoints;\n\n@value colors: \"components/library/style/colors.css\";\n@value color-purple, color-purple-bg, color-gray, color-text-subtle from colors;\n\n.content {\n  width: 100%;\n  margin: auto;\n  position: relative;\n  background: linear-gradient(90deg, rgba(248,250,255,1) 0%, rgba(248,250,255,1) 35%, rgba(255,255,255,1) 100%);\n}\n\n.row {\n  width: 100%;\n  max-width: 1440px;\n  margin: auto;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n}\n\n.container {\n  background-color: #F8FAFF;\n  min-height: calc(100vh - 75px);\n  width: 65%;\n  padding: 16px 32px 48px 0;\n  box-sizing: border-box;\n}\n\n.form {\n  width: 50%;\n}\n\n.subtle {\n  color: color-text-subtle;\n}\n\n.subtitle {\n  margin-top: 32px;\n}\n\n.required {\n  color: color-purple;\n  margin: 0 4px;\n}\n\n.buttonGroup {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  justify-content: flex-end;\n  margin: 32px 0;\n}\n\n.button {\n  margin-right: 24px;\n}\n\n.link {\n  font-weight: 400;\n  color: color-purple;\n  text-decoration: underline;\n}\n\n.row {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n}\n\n.inputRow {\n  width: 49%;\n}\n\n.zip {\n  width: 35%;\n}\n\n.city {\n  width: 60%;\n}\n\n.background {\n  position: fixed;\n  top: 0;\n  right: 0;\n  z-index: 1000;\n\n  width: 100%;\n  height: 100vh;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  background-color: rgba(0, 0, 0, 0.15);\n}\n\n.modal {\n  background-color: white;\n  border-radius: 5px;\n  padding: 24px;\n  width: 500px;\n\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.modal h1 {\n  font-size: 24px;\n  margin: 0;\n}\n\n.modal p {\n  text-align: center;\n}\n\n.modal button {\n  width: 100%;\n}\n\n.image {\n  background-color: #EDFAF4;\n  width: 80px;\n  height: 80px;\n  border-radius: 80px;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  margin: auto;\n}\n\n.title {\n  font-family: Roboto, sans-serif;\n  font-style: normal;\n  font-weight: 500;\n  font-size: 18px;\n  line-height: 21px;\n  letter-spacing: 0.005em;\n  margin-bottom: 0;\n  margin-top: 0;\n}\n\n.description {\n  font-family: Roboto, sans-serif;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 16px;\n  line-height: 150%;\n  letter-spacing: 0.005em;\n  color: rgba(0, 0, 0, 0.55);\n  margin-top: 8px;\n  margin-bottom: 8px;\n  width: 100%;\n}\n\n.finalize {\n  width: 100%;\n}\n\n.submit {\n  display: flex;\n  width: 100%;\n}\n\n.displayMobile {\n  display: none;\n}\n\n.displayDesktop {\n  display: flex;\n}\n\n@media screen and (max-width: 1440px) {\n  .row {\n    width: 90%;\n  }\n}\n\n@media screen and (max-width: tablet) {\n  .container {\n    max-height: calc(90vh - 75px);\n    min-height: unset;\n    overflow-y: scroll;\n  }\n\n  .displayMobile {\n    display: block;\n  }\n\n  .submit.displayMobile {\n    margin-top: 16px;\n    font-size: 16px;\n    padding: 16px;\n  }\n\n  .displayDesktop {\n    display: none;\n  }\n\n  .modal {\n    width: 90%;\n    box-sizing: border-box;\n  }\n\n  .row {\n    flex-direction: column;\n  }\n\n  .container {\n    width: 100%;\n    padding: 16px;\n    margin-top: 0;\n    box-sizing: border-box;\n\n    position: fixed;\n    top: 75px;\n  }\n\n  .image {\n    width: 60px;\n    height: 60px;\n    margin-bottom: 16px;\n  }\n}\n\n@media screen and (max-width: tablet-l) {\n  .form {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"breakpoints": `"components/library/style/breakpoint.css"`,
	"desktop": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["desktop"]}`,
	"laptop": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["laptop"]}`,
	"tablet-l": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["tablet-l"]}`,
	"tablet": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["tablet"]}`,
	"mobile": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["mobile"]}`,
	"mobile-xs": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["mobile-xs"]}`,
	"colors": `"components/library/style/colors.css"`,
	"color-purple": `${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-purple"]}`,
	"color-purple-bg": `${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-purple-bg"]}`,
	"color-gray": `${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-gray"]}`,
	"color-text-subtle": `${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-text-subtle"]}`,
	"content": `I1i0baKYJaJf9mmLeqcn`,
	"row": `AsNDCWieqtYSFydPs9C_`,
	"container": `osMEvPrmWffBIa5oYfUf`,
	"form": `TXfRDDLWBXYXUPKU9Lu3`,
	"subtle": `F5qt7iAYuutJGTGWOjlw`,
	"subtitle": `XDPtHezfCUijCss0LV4A`,
	"required": `XrBJoS6b31pPaKsMvqGq`,
	"buttonGroup": `QkoJ3qhs9MuLwFwLxKjf`,
	"button": `_c7v1tRfVVLWGwPfP_AL`,
	"link": `MIbn3hbMAElVwIQggRic`,
	"inputRow": `pBTD_GVMGJk6GGFaeM8r`,
	"zip": `cuDzD625J6ae9Z9jeHAB`,
	"city": `gO0WqHvnakkrv3S2oqEe`,
	"background": `TZ3znXv7xT9XKwRDNyqP`,
	"modal": `CjjEHaIHqFgQc9YdrBYL`,
	"image": `nEVtP4tS6RwVrBCTgKQk`,
	"title": `ryaRE5G6WbH09UicHFbg`,
	"description": `uJbbHv89TbfWTdNgbeGX`,
	"finalize": `vYrZluzCt4pGEywK2cMk`,
	"submit": `RuBaiUJ24YWwTalBJegw`,
	"displayMobile": `tT6mXb4RO6xmNZQGOPXe`,
	"displayDesktop": `voFRNNluY9MferQhrPY3`
};
export default ___CSS_LOADER_EXPORT___;
